// extracted by mini-css-extract-plugin
export default {"menuItem":"menu-item_menuItem__1IpS5","imageBox":"menu-item_imageBox__mBEFV","title":"menu-item_title__53-+1"};